export default [
    {
        path: "/admin/holiday",
        name: "holiday",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/holiday")
    }
];
